document.querySelectorAll('[data-product-tabs]').forEach((tabsEl) => {
  const triggers = tabsEl.querySelectorAll('[data-tab-trigger]');
  const panels = tabsEl.querySelectorAll('[data-tab-panel]');

  if (panels.length) panels[0].hidden = false;

  triggers.forEach((trigger) => {
    trigger.addEventListener('click', () => {
      const targetId = trigger.getAttribute('data-tab-target');

      triggers.forEach((t) => {
        t.classList.remove('is-active');
        t.setAttribute('aria-selected', 'false');
      });
      trigger.classList.add('is-active');
      trigger.setAttribute('aria-selected', 'true');

      panels.forEach((panel) => {
        panel.hidden = panel.id !== targetId;
      });
    });
  });
});